import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import {
  Department,
  DepartmentUpdate,
  DepartmentDelete,
  DesignationName,
  DesignationUpdate,
  DesignationDelete,
  AddSubCompany,
  UpdateSubCompany,
  DeleteSubCompany,
  AttendancePolicyAdd,
  AttendancePolicyUpdate,
  AttendancePolicyDelete,
  Woksiteadd,
  Woksiteupdate,
  WoksiteDelete,
  CalenderAdd,
  CalenderUpdate,
  CalenderDelete,
  InterCom,
  InterComUpdate,
  InterComDelete,
  WeeklyOffPolicy,
  WeeklyOffPolicyDelete,
  WeeklyOffPolicyUpdate,
  EsslList,
  EsslUpdate,
  EsslDelete,
  SalaryCalculationPolicyAdd,
  SalaryCalculationPolicyUpdate,
  SalaryCalculationPolicyDelete,
  SalaryStructureHeadingAdd,
  SalaryStructureHeadingUpdate,
  SalaryStructureHeadingDelete,
  AddWeeklyOffPolicy,
  UpdateWeeklyOffPolicy,
  DepartmentHierarchyAdd,
  DepartmentHierarchyUpdate,
  DepartmentHierarchyDelete,
  EmployeeHierarchyAdd,
  EmployeeHierarchyDelete,
  EmployeeHierarchyUpdate,
} from "./Wfmmodels";
import { BASE_URL, IMAGE_URL } from "../../config/axios";
import axios from "axios";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";

import usePermission from "../../config/permissions";
import { formatDate, formatDateTime, formattedDateLong } from "../Date";
import { CustomImageModal, customSortByKey, handleErrorToast, renderDangerousHTML, showConfirmToast } from "../CustomFunctions";
import { CSSForDropdownFilter, CSSForFilterDropdown } from "../CustomUtilities";
import { Arrow, CircularGrid, Office, Search, SearchBig, SearchSmall, Employee, Active, Eye, UpdatePencil, AddwithBlueCircle } from "../AllSvg";
import { AddSalaryStructurePolicyFormat, DeleteSalaryStructurePolicyFormat, ViewSalaryPolicyFormatDeductions } from "../UserDetails/userDetails-comp/SalaryStructureComponents";
import UserDefaultLogo from "../UserDetails/UserDefaultLogo";
import { ViewLetterBuilder } from "../DynamicBuilders/LetterBuilderManagement/LetterTemplateComponentsTesting";

const DepartmentTable = () => {
  const [departmentname, setDepartmentname] = useState([]);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY, SUPER_ADMIN, PERMISSION_HR_ADMIN } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [buffer, setBuffering] = useState(true); //buffering logic

  const getDepartment = async () => {
    setBuffering(true); // Start Buffering
    try {
      // const res = await axios.get(`${BASE_URL}/wfm/departmentwfm/`);
      const res = await axios.get(PERMISSION_AUTHORITY ?
        `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${toggleCompany}/active/`
        :
        `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${toggleCompany}/active/`
      );
      setDepartmentname(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false);// End Buffering
    }
  };

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  useEffect(() => {
    getDepartment();
  }, [toggleCompany]);

  return (
    <div className="table-css-white-background">
      <div className="table-heading-flex">
        <div className="repo-heading font-weight500    font-size-heading">Department</div>
        <div className="field-cont">

          {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div">
            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
              <option value="null">Select Sub Company</option>
              {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

            </select>
          </div> : null
          }
          <div className="table-searchh field-cont-div">
            <div>
              <SearchSmall />
            </div>
            <div>
              <input
                placeholder="Search"
                className="navbar-inputt font-weight400  font-size-text"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </div>

          <Department
            getDepartment={getDepartment}
            departmentname={departmentname}
          />
        </div>
      </div>

      <table className="table-css">
        <thead>
          <tr className="custom-table-head-tr">
            <th className="align-left">ID</th>
            <th className="align-center">Department</th>
            <th className="align-center">Company</th>
            <th className="align-center">Employee Count</th>
            <th className="align-center">Employee View</th>
            <th className="align-center">Updated at</th>
            <th className="align-center">Updated by</th>
            <th className="align-right width-10vw">Action</th>
          </tr>
        </thead>
        {buffer ? <div className="spinner"></div> :
          <tbody>
            {departmentname
              ?.filter((e) =>
                e.title.toLowerCase().includes(searchQuery.toLowerCase())
              )
              .sort((a, b) =>
                a.title.localeCompare(b.title, "en", { ignorePunctuation: true })
              )
              .map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="tr-border-bottom">
                    <td colSpan="6"></td>
                  </tr>
                  <tr className="custom-table-head-td">
                    <td className="align-left">{index + 1}</td>
                    <td className="align-center">{i.title}</td>
                    <td className="align-center">{i.sub_company_name}</td>

                    <td className="align-center">{i?.active_employee_count}</td>
                    {/* <td className="align-center">View </td> */}
                    <td className="align-center">
                      <EmployeebyDepartmentTable department={i} />{" "}
                    </td>
                    <td className="align-center">
                      {formatDateTime(i.updated_at).shortfull}
                    </td>

                    <td className="align-center">
                      {i.updated_by &&
                        <CustomImageModal customStyle>
                          {i.updated_by_profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.updated_by_profilepic}`}
                              className="profile-img"
                              alt={i?.updated_by_name}
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{ name: i.updated_by_name, profilepic: '' }} customStyleforParent={"reqOutDuty-default-logo"} customStyleforChild={'small-profile'}
                            />
                          )}
                        </CustomImageModal>
                      }
                      <p> {i.updated_by && `${i.updated_by} - `}{i.updated_by_name}</p>
                    </td>

                    <td className="align-right width-5vw ">
                      {PERMISSION_HR_ADMIN && (
                        <DepartmentUpdate
                          i={i}
                          getDepartment={getDepartment}
                          departmentname={departmentname}
                        />
                      )}
                      {PERMISSION_AUTHORITY && i?.total_employee_count === 0 && (
                        <DepartmentDelete i={i} getDepartment={getDepartment} />
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        }
      </table>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};

const EmployeebyDepartmentTable = ({ department }) => {
  const [show, setShow] = useState(false);
  const [buffer, setBuffering] = useState(true); //buffering logic

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    getDepartmentEmployees(department.id);
  };

  const [departmentEmployees, setDepartmentEmployees] = useState([]);

  const getDepartmentEmployees = async (department) => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/employeedetailsbydepartment/${department}/active/`
      );
      const sortedList = customSortByKey(res.data, "emp_code");

      setDepartmentEmployees(sortedList);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const navigate = useNavigate();

  const currentUrl = window.location.href;
  const urlParts = currentUrl.split('/');
  const url = urlParts[3]
  // console.log("url")
  // console.log(url)
  const Viewdetails = (emp_code, user_detail) => {
    navigate(`/${url}/userdetailscrud/${emp_code}/${user_detail}/`);
  };
  return (
    <>
      <button
        className=""
        title="View Employees"
        style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
        onClick={handleShow}
      >
        View
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <>
            {/* <div className="attendance-history-cont">
              <div className="attendance-heading  font-weight500    font-size-heading"></div>
            </div> */}
            <div className="table-css-white-background">
              <div className="table-heading-flex">
                <div className="repo-heading font-weight500    font-size-heading">
                  Employees in : <br />
                  {department.title}
                </div>
                <div className="flex-row">
                  <div className="table-searchh">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="12"
                        viewBox="0 0 11 12"
                        fill="none"
                      >
                        <circle
                          cx="5"
                          cy="5"
                          r="4.3"
                          stroke="#2B3674"
                          strokeWidth="1.4"
                        />
                        <line
                          x1="10.0101"
                          y1="11"
                          x2="8"
                          y2="8.98995"
                          stroke="#2B3674"
                          strokeWidth="1.4"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <input
                        placeholder="Search"
                        className="navbar-inputt font-weight400  font-size-text"
                        value={searchQuery}
                        onChange={handleSearchChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left">ID</th>
                    <th className="align-center">Emp Code</th>
                    <th className="align-center"> Name </th>
                    <th className="align-center">Employee View</th>
                  </tr>
                </thead>
                {buffer ? <div className="spinner"></div> : //buffering logic
                  <tbody>
                    {departmentEmployees
                      ?.filter(
                        (e) =>
                          e.name
                            .toLowerCase()
                            .includes(searchQuery.toLowerCase()) ||
                          e.emp_code
                            .toString()
                            .includes(searchQuery.toLowerCase())
                      )
                      .sort((a, b) => a.emp_code - b.emp_code)
                      .map((i, index) => (
                        <React.Fragment key={index}>
                          {/* <tr className="tr-border-bottom">
                          <td colSpan="6"></td>
                        </tr> */}
                          <tr className="custom-table-head-td">
                            <td className="align-left">{index + 1}</td>
                            <td className="align-center">{i.emp_code}</td>
                            <td className="align-center">{i.name}</td>

                            <td className="align-center">
                              <button
                                className="employee-edit"
                                onClick={() =>
                                  Viewdetails(i.emp_code, i.user_detail)
                                }
                                title="View Profile"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="40"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                >
                                  <circle cx="15" cy="15" r="15" fill="#F6F7F9" />
                                  <path
                                    d="M23.8913 14.5437C22.1966 11.2372 18.8416 9 15 9C11.1584 9 7.80249 11.2388 6.10873 14.5441C6.03725 14.6855 6 14.8417 6 15.0002C6 15.1586 6.03725 15.3148 6.10873 15.4563C7.80342 18.7628 11.1584 21 15 21C18.8416 21 22.1975 18.7612 23.8913 15.4559C23.9628 15.3145 24 15.1583 24 14.9998C24 14.8414 23.9628 14.6852 23.8913 14.5437ZM15 19.5C14.11 19.5 13.24 19.2361 12.4999 18.7416C11.7599 18.2471 11.1831 17.5443 10.8425 16.7221C10.5019 15.8998 10.4128 14.995 10.5865 14.1221C10.7601 13.2492 11.1887 12.4474 11.818 11.818C12.4474 11.1887 13.2492 10.7601 14.1221 10.5865C14.995 10.4128 15.8998 10.5019 16.7221 10.8425C17.5443 11.1831 18.2472 11.7599 18.7416 12.4999C19.2361 13.24 19.5 14.11 19.5 15C19.5003 15.591 19.3841 16.1763 19.1581 16.7224C18.932 17.2685 18.6005 17.7647 18.1826 18.1826C17.7647 18.6005 17.2685 18.932 16.7224 19.158C16.1763 19.3841 15.591 19.5003 15 19.5ZM15 12C14.7322 12.0037 14.4662 12.0436 14.2091 12.1184C14.421 12.4065 14.5227 12.7609 14.4957 13.1175C14.4688 13.4741 14.3149 13.8092 14.062 14.062C13.8092 14.3149 13.4741 14.4688 13.1175 14.4957C12.7609 14.5227 12.4065 14.421 12.1184 14.2091C11.9544 14.8133 11.984 15.4538 12.2031 16.0403C12.4221 16.6269 12.8196 17.1299 13.3396 17.4787C13.8595 17.8275 14.4758 18.0045 15.1016 17.9847C15.7274 17.965 16.3312 17.7495 16.8281 17.3685C17.325 16.9876 17.6899 16.4604 17.8715 15.8612C18.0531 15.2621 18.0422 14.621 17.8404 14.0283C17.6386 13.4356 17.256 12.9211 16.7465 12.5573C16.2369 12.1934 15.6261 11.9985 15 12Z"
                                    fill="#2576BC"
                                  />
                                </svg>
                              </button>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                }
              </table>
            </div>
          </>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const DesignationTable = () => {
  const [buffer, setBuffering] = useState(true); //buffering logic
  const [designationname, setDesignationname] = useState([]);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY, SUPER_ADMIN, PERMISSION_HR_ADMIN } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(PERMISSION_AUTHORITY ? "null" :
    sessionStorage.getItem("company_id")
  );
  const [searchQuery, setSearchQuery] = useState("");

  const getDesignation = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        PERMISSION_AUTHORITY ?
          `${BASE_URL}/wfm/designationfilterbysubcompanycount/${toggleCompany}/active/`
          :
          `${BASE_URL}/wfm/designationfilterbysubcompanycount/${toggleCompany}/active/`
      );
      // const res = await axios.get(`${BASE_URL}/wfm/designationwfm/`);
      setDesignationname(res.data);
      setBuffering(false);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  useEffect(() => {
    getDesignation();
  }, [toggleCompany]);

  return (
    <div className="table-css-white-background">
      <div className="table-heading-flex">
        <div className="repo-heading font-weight500    font-size-heading">Designation</div>
        <div className="field-cont">
          {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div">
            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
              <option value="null">Select Sub Company</option>
              {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

            </select>
          </div> : null
          }
          <div className="table-searchh">
            <div>
              <SearchSmall />
            </div>
            <div>
              <input
                placeholder="Search"
                className="navbar-inputt font-weight400  font-size-text"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <DesignationName
            getDesignation={getDesignation}
            designationname={designationname}
          />
        </div>
      </div>
      <table className="table-css">
        <thead>
          <tr className="custom-table-head-tr">
            <th className="align-left">ID</th>
            <th className="align-center">Designation</th>
            <th className="align-center">Company</th>
            <th className="align-center">Employee Count</th>
            <th className="align-center">Employee View</th>
            <th className="align-center">Updated at</th>
            <th className="align-center">Updated by</th>
            <th className="align-right width-10vw">Action</th>
          </tr>
        </thead>
        {buffer ? <div className="spinner"></div> :

          <tbody>
            {designationname
              ?.filter((e) =>
                e.title.toLowerCase().includes(searchQuery.toLowerCase())
              )
              .sort((a, b) =>
                a.title.localeCompare(b.title, "en", { ignorePunctuation: true })
              )
              .map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="tr-border-bottom">
                    <td colSpan="6"></td>
                  </tr>
                  <tr className="custom-table-head-td">
                    <td className="align-left">{index + 1}</td>
                    <td className="align-center">{i.title}</td>
                    <td className="align-center">{i.sub_company_name}</td>
                    <td className="align-center">{i.active_employee_count}</td>
                    <td className="align-center">
                      <EmployeebyDesignationTable designation={i} />
                    </td>
                    <td className="align-center">
                      {formatDateTime(i.updated_at).shortfull}
                    </td>
                    <td className="align-center">
                      {i.updated_by &&
                        <CustomImageModal customStyle>
                          {i.updated_by_profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.updated_by_profilepic}`}
                              className="profile-img"
                              alt={i?.updated_by_name}
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{ name: i.updated_by_name, profilepic: '' }} customStyleforParent={"reqOutDuty-default-logo"} customStyleforChild={'small-profile'}
                            />
                          )}
                        </CustomImageModal>
                      }
                      <p> {i.updated_by && `${i.updated_by} - `}{i.updated_by_name}</p>
                    </td>

                    <td className="align-right width-5vw ">
                      {PERMISSION_HR_ADMIN && (
                        <DesignationUpdate
                          i={i}
                          getDesignation={getDesignation}
                          designationname={designationname}
                        />
                      )}
                      {PERMISSION_AUTHORITY && i?.total_employee_count == 0 && (
                        <DesignationDelete i={i} getDesignation={getDesignation} />
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>}
      </table>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};

const EmployeebyDesignationTable = ({ designation }) => {
  const [show, setShow] = useState(false);
  const [buffer, setBuffering] = useState(true); //buffering logic

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    getDesignationEmployees(designation.id);
  };
  const [designationEmployees, setDesignationEmployees] = useState([]);

  const getDesignationEmployees = async (designationId) => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/employeedetailsbydesignation/${designationId}/`
      );
      setDesignationEmployees(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split('/');
  const url = urlParts[3]
  const Viewdetails = (emp_code, user_detail) => {
    navigate(`/${url}/userdetailscrud/${emp_code}/${user_detail}/`);
  };
  return (
    <>
      <button
        className=""
        title="View Employees"
        style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
        onClick={handleShow}
      >
        View
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <>
            {/* <div className="attendance-history-cont">
              <div className="attendance-heading  font-weight500    font-size-heading"></div>
            </div> */}
            <div className="table-css-white-background">
              <div className="table-heading-flex">
                <div className="repo-heading font-weight500    font-size-heading">
                  Employees as : <br />
                  {designation.title}
                </div>
                <div className="flex-row">
                  <div className="table-searchh">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="12"
                        viewBox="0 0 11 12"
                        fill="none"
                      >
                        <circle
                          cx="5"
                          cy="5"
                          r="4.3"
                          stroke="#2B3674"
                          strokeWidth="1.4"
                        />
                        <line
                          x1="10.0101"
                          y1="11"
                          x2="8"
                          y2="8.98995"
                          stroke="#2B3674"
                          strokeWidth="1.4"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <input
                        placeholder="Search"
                        className="navbar-inputt font-weight400  font-size-text"
                        value={searchQuery}
                        onChange={handleSearchChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left">ID</th>
                    <th className="align-center">Emp Code</th>
                    <th className="align-center"> Name </th>
                    <th className="align-center">Employee View</th>
                  </tr>
                </thead>
                {buffer ? <div className="spinner"></div> : //buffering logic
                  <tbody>
                    {designationEmployees
                      ?.filter(
                        (e) =>
                          e.name
                            .toLowerCase()
                            .includes(searchQuery.toLowerCase()) ||
                          e.emp_code
                            .toString()
                            .includes(searchQuery.toLowerCase())
                      )
                      .sort((a, b) => a.emp_code - b.emp_code)
                      .map((i, index) => (
                        <React.Fragment key={index}>
                          {/* <tr className="tr-border-bottom">
                          <td colSpan="6"></td>
                        </tr> */}
                          <tr className="custom-table-head-td">
                            <td className="align-left">{index + 1}</td>
                            <td className="align-center">{i.emp_code}</td>
                            <td className="align-center">{i.name}</td>

                            <td className="align-center">
                              <button
                                onClick={() =>
                                  Viewdetails(i.emp_code, i.user_detail)
                                }
                                title="View Profile"
                              >
                                <Eye />
                              </button>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>}
              </table>
            </div>
          </>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const Subcompany = () => {
  const { PERMISSION_AUTHORITY, SUPER_ADMIN, PERMISSION_HR_ADMIN } = usePermission();
  const [buffer, setBuffering] = useState(true); //buffering logic

  const [SubCompany, setSubCompany] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const getSubCompany = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      // const res = await axios.get(`${BASE_URL}/wfm/subcompanywfm/`);
      // const res = await axios.get(`${BASE_URL}/wfm/subcompanyfilterbysubcompanycount/${sessionStorage.getItem('company_id')}/active/`);
      const res = await axios.get(
        `${BASE_URL}/wfm/subcompanyfilterbysubcompanycount/null/active/`
      );
      setSubCompany(res.data);
    } catch (err) {
      //toast Logic
      handleErrorToast(err)
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getSubCompany();
  }, []);


  const SubCompanyList = SUPER_ADMIN ?
    SubCompany
    :
    SubCompany?.filter((e) =>
      e.id === sessionStorage.getItem('company_id')
    )

  return (
    <div className="table-css-white-background">
      <div className="table-heading-flex">
        <div className="repo-heading font-weight500    font-size-heading">Sub Company</div>
        <div className="flex-row">

          {/* <div className="table-searchh">
            <div>
              <SearchSmall />
            </div>
            <div>
              <input
                placeholder="Search"
                className="navbar-inputt font-weight400  font-size-text"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </div> */}

          {SUPER_ADMIN ? (
            <AddSubCompany getSubCompany={getSubCompany} />
          ) : null}
        </div>
      </div>
      <table className="table-css">
        <thead>
          <tr className="custom-table-head-tr">
            <th className="align-left">ID</th>
            <th className="align-center">Logo</th>
            <th className="align-center">Name</th>
            <th className="align-center">Company Full Name</th>
            <th className="align-center">Company Address</th>
            <th className="align-center">Company GST</th>
            <th className="align-center">Company Number</th>
            <th className="align-center">Employee Count</th>
            <th className="align-center">Employee View</th>
            <th className="align-center">Last Updated</th>
            <th className="align-center">View Template</th>
            <th className="align-right">Action</th>
          </tr>
        </thead>
        {buffer ? <div className="spinner"></div> : //buffering logic
          <tbody>
            {SubCompanyList
              ?.filter((e) =>
                e.title.toLowerCase().includes(searchQuery.toLowerCase())
              )
              .sort((a, b) =>
                a.title.localeCompare(b.title, "en", { ignorePunctuation: true })
              )
              .map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="tr-border-bottom">
                    <td colSpan="6"></td>
                  </tr>
                  <tr className="custom-table-head-td">
                    <td className="align-left">{index + 1}</td>
                    <td className="align-center">
                      {i?.company_logo ? (
                        <CustomImageModal customStyle>
                          <img
                            src={i?.company_logo}
                            alt="Logo Preview" className='width-5vw image-radius'

                          />
                        </CustomImageModal>
                      ) : (
                        '-No Logo-'
                      )}
                      {/* { || '-'} */}
                    </td>
                    <td className="align-center">{i?.title || '-'}</td>
                    <td className="align-center">{i?.company_name || '-'}</td>
                    {/* <td className="align-center width-10vw text-justify" dangerouslySetInnerHTML={{ __html: i?.company_address }}></td> */}
                    <td className="align-center width-10vw text-justify">{renderDangerousHTML(i?.company_address)}</td>
                    <td className="align-center">{i?.company_gst || '-'}</td>
                    <td className="align-center">{i?.company_number || '-'}</td>
                    <td className="align-center">{i?.current_employee_count}</td>
                    <td className="align-center">
                      <EmployeebySubCompanyTable subcompany={i} />
                    </td>

                    <td className="align-center">
                      {i.updated_by &&
                        <CustomImageModal customStyle>
                          {i.updated_by_profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.updated_by_profilepic}`}
                              className="profile-img"
                              alt={i?.updated_by_name}
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{ name: i.updated_by_name, profilepic: '' }} customStyleforParent={"reqOutDuty-default-logo"} customStyleforChild={'small-profile'}
                            />
                          )}
                        </CustomImageModal>
                      }
                      <p> {i.updated_by && `${i.updated_by} - `}{i.updated_by_name}</p>
                      At {formatDateTime(i.updated_at).shortfull}

                    </td>

                    <td className="align-center">

                      {i?.company_letter_template ? <ViewLetterBuilder
                        buttonDisplay={'Eye-Name'}
                        templateID={i?.company_letter_template}
                      />
                        :
                        'No Default Template'
                      }
                    </td>

                    <td className="align-right">
                      {
                        i.id === sessionStorage.getItem('company_id') &&
                        <>
                          {PERMISSION_HR_ADMIN && (
                            <UpdateSubCompany i={i} getSubCompany={getSubCompany} />
                          )}
                          {PERMISSION_AUTHORITY && i?.total_employee_count == 0 &&
                            <DeleteSubCompany i={i} getSubCompany={getSubCompany} />
                          }
                        </>}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        }
      </table>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div >
  );
};

const EmployeebySubCompanyTable = ({ subcompany }) => {
  const [show, setShow] = useState(false);
  const [buffer, setBuffering] = useState(true); //buffering logic

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    getSubCompanyEmployees(subcompany.id);
  };

  const [subcompanyEmployees, setSubCompanyEmployees] = useState([]);

  const getSubCompanyEmployees = async (subcompanyId) => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/employeedetailsbysubcompany/${subcompanyId}/`
      );
      const sortedList = customSortByKey(res.data, "emp_code");

      setSubCompanyEmployees(sortedList);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // useEffect(() => {
  //   getSubCompanyEmployees();
  // }, []);

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split('/');
  const url = urlParts[3]
  const Viewdetails = (emp_code, user_detail) => {
    navigate(`/${url}/userdetailscrud/${emp_code}/${user_detail}/`);
  };
  return (
    <>
      <button
        className=""
        title="View Employees"
        style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
        onClick={handleShow}
      >
        View
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <>
            {/* <div className="attendance-history-cont">
              <div className="attendance-heading  font-weight500    font-size-heading"></div>
            </div> */}
            <div className="table-css-white-background">
              <div className="table-heading-flex">
                <div className="repo-heading font-weight500    font-size-heading">
                  Employees in : <br />
                  {subcompany.title}
                </div>
                <div className="flex-row">
                  <div className="table-searchh">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="12"
                        viewBox="0 0 11 12"
                        fill="none"
                      >
                        <circle
                          cx="5"
                          cy="5"
                          r="4.3"
                          stroke="#2B3674"
                          strokeWidth="1.4"
                        />
                        <line
                          x1="10.0101"
                          y1="11"
                          x2="8"
                          y2="8.98995"
                          stroke="#2B3674"
                          strokeWidth="1.4"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <input
                        placeholder="Search"
                        className="navbar-inputt font-weight400  font-size-text"
                        value={searchQuery}
                        onChange={handleSearchChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left">ID</th>
                    <th className="align-center">Emp Code</th>
                    <th className="align-center"> Name </th>
                    <th className="align-center">Employee View</th>
                  </tr>
                </thead>
                {buffer ? <div className="spinner"></div> : //buffering logic
                  <tbody>
                    {subcompanyEmployees
                      ?.filter(
                        (e) =>
                          e.name
                            .toLowerCase()
                            .includes(searchQuery.toLowerCase()) ||
                          e.emp_code
                            .toString()
                            .includes(searchQuery.toLowerCase())
                      )
                      .sort((a, b) => a.emp_code - b.emp_code)
                      .map((i, index) => (
                        <React.Fragment key={index}>
                          {/* <tr className="tr-border-bottom">
                          <td colSpan="6"></td>
                        </tr> */}
                          <tr className="custom-table-head-td">
                            <td className="align-left">{index + 1}</td>
                            <td className="align-center">{i.emp_code}</td>
                            <td className="align-center">{i.name}</td>

                            <td className="align-center">
                              <button
                                className="employee-edit"
                                onClick={() =>
                                  Viewdetails(i.emp_code, i.user_detail)
                                }
                                title="View Profile"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="40"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                >
                                  <circle cx="15" cy="15" r="15" fill="#F6F7F9" />
                                  <path
                                    d="M23.8913 14.5437C22.1966 11.2372 18.8416 9 15 9C11.1584 9 7.80249 11.2388 6.10873 14.5441C6.03725 14.6855 6 14.8417 6 15.0002C6 15.1586 6.03725 15.3148 6.10873 15.4563C7.80342 18.7628 11.1584 21 15 21C18.8416 21 22.1975 18.7612 23.8913 15.4559C23.9628 15.3145 24 15.1583 24 14.9998C24 14.8414 23.9628 14.6852 23.8913 14.5437ZM15 19.5C14.11 19.5 13.24 19.2361 12.4999 18.7416C11.7599 18.2471 11.1831 17.5443 10.8425 16.7221C10.5019 15.8998 10.4128 14.995 10.5865 14.1221C10.7601 13.2492 11.1887 12.4474 11.818 11.818C12.4474 11.1887 13.2492 10.7601 14.1221 10.5865C14.995 10.4128 15.8998 10.5019 16.7221 10.8425C17.5443 11.1831 18.2472 11.7599 18.7416 12.4999C19.2361 13.24 19.5 14.11 19.5 15C19.5003 15.591 19.3841 16.1763 19.1581 16.7224C18.932 17.2685 18.6005 17.7647 18.1826 18.1826C17.7647 18.6005 17.2685 18.932 16.7224 19.158C16.1763 19.3841 15.591 19.5003 15 19.5ZM15 12C14.7322 12.0037 14.4662 12.0436 14.2091 12.1184C14.421 12.4065 14.5227 12.7609 14.4957 13.1175C14.4688 13.4741 14.3149 13.8092 14.062 14.062C13.8092 14.3149 13.4741 14.4688 13.1175 14.4957C12.7609 14.5227 12.4065 14.421 12.1184 14.2091C11.9544 14.8133 11.984 15.4538 12.2031 16.0403C12.4221 16.6269 12.8196 17.1299 13.3396 17.4787C13.8595 17.8275 14.4758 18.0045 15.1016 17.9847C15.7274 17.965 16.3312 17.7495 16.8281 17.3685C17.325 16.9876 17.6899 16.4604 17.8715 15.8612C18.0531 15.2621 18.0422 14.621 17.8404 14.0283C17.6386 13.4356 17.256 12.9211 16.7465 12.5573C16.2369 12.1934 15.6261 11.9985 15 12Z"
                                    fill="#2576BC"
                                  />
                                </svg>
                              </button>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                }
              </table>
            </div>
          </>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const Worksite = () => {
  const [worksite, setWorksite] = useState([]);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY, SUPER_ADMIN, PERMISSION_HR_ADMIN } = usePermission();
  const [toggleCompany, setToggleCompany] = useState("null");
  const [buffer, setBuffering] = useState(true); //buffering logic


  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const getWoksiteList = async () => {
    try {
      setBuffering(true); //buffering logic // Start Buffering 
      // const res = await axios.get(`${BASE_URL}/wfm/worksitewfm/`);
      // const res = await axios.get(`${BASE_URL}/wfm/worksitefilterbysubcompanycount/${sessionStorage.getItem('company_id')}/active/`);
      const res = await axios.get(
        PERMISSION_AUTHORITY ?
          `${BASE_URL}/wfm/worksitefilterbysubcompanycount/${toggleCompany}/active/`
          :
          `${BASE_URL}/wfm/worksitefilterbysubcompanycount/${toggleCompany}/active/`
      );
      setWorksite(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };
  useEffect(() => {
    getWoksiteList();
  }, [toggleCompany]);
  return (
    <div className="table-css-white-background">
      <div className="table-heading-flex">
        <div className="repo-heading font-weight500    font-size-heading">Work Site</div>
        <div className="field-cont">

          {PERMISSION_AUTHORITY ? <div className="table-searchh dropdown-container field-cont-div">
            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
              <option value="null">Select Sub Company</option>
              {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

            </select>
          </div> : null
          }<div className="table-searchh">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="11"
                height="12"
                viewBox="0 0 11 12"
                fill="none"
              >
                <circle
                  cx="5"
                  cy="5"
                  r="4.3"
                  stroke="#2B3674"
                  strokeWidth="1.4"
                />
                <line
                  x1="10.0101"
                  y1="11"
                  x2="8"
                  y2="8.98995"
                  stroke="#2B3674"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <div>
              <input
                placeholder="Search"
                className="navbar-inputt font-weight400  font-size-text"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <Woksiteadd getWoksiteList={getWoksiteList} />
        </div>
      </div>
      <table className="table-css">
        <thead>
          <tr className="custom-table-head-tr">
            <th className="align-left">ID</th>
            <th className="align-center">Woksite Name</th>
            <th className="align-center">Company</th>
            <th className="align-center">Employee Count</th>
            <th className="align-center">Employee View</th>
            <th className="align-center">Updated at</th>
            <th className="align-center">Updated by</th>
            <th className="align-right width-10vw">Action</th>
          </tr>
        </thead>
        {buffer ? <div className="spinner"></div> : //buffering logic
          <tbody>
            {worksite
              ?.filter((e) =>
                e.title.toLowerCase().includes(searchQuery.toLowerCase())
              )
              .sort((a, b) =>
                a.title.localeCompare(b.title, "en", { ignorePunctuation: true })
              )
              .map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="tr-border-bottom">
                    <td colSpan="6"></td>
                  </tr>
                  <tr className="custom-table-head-td">
                    <td className="align-left">{index + 1}</td>
                    <td className="align-center">{i.title}</td>
                    <td className="align-center">{i.sub_company_name}</td>
                    <td className="align-center">{i.active_employee_count}</td>
                    <td className="align-center">
                      <EmployeebyWorkSiteTable worksite={i} />
                    </td>
                    <td className="align-center">
                      {formatDateTime(i.updated_at).shortfull}
                    </td>

                    <td className="align-center">
                      {i.updated_by &&
                        <CustomImageModal customStyle>
                          {i.updated_by_profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.updated_by_profilepic}`}
                              className="profile-img"
                              alt={i?.updated_by_name}
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{ name: i.updated_by_name, profilepic: '' }} customStyleforParent={"reqOutDuty-default-logo"} customStyleforChild={'small-profile'}
                            />
                          )}
                        </CustomImageModal>
                      }
                      <p> {i.updated_by && `${i.updated_by} - `}{i.updated_by_name}</p>
                    </td>

                    <td className="align-right width-5vw ">
                      {PERMISSION_HR_ADMIN && (

                        <Woksiteupdate i={i} getWoksiteList={getWoksiteList} />
                      )}
                      {PERMISSION_AUTHORITY && i?.total_employee_count == 0 && (
                        <WoksiteDelete i={i} getWoksiteList={getWoksiteList} />
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        }
      </table>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};

const EmployeebyWorkSiteTable = ({ worksite }) => {
  const [show, setShow] = useState(false);
  const [buffer, setBuffering] = useState(true); //buffering logic

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    getWorkSiteEmployees(worksite.id);
  };

  const [worksiteEmployees, setWorkSiteEmployees] = useState([]);

  const getWorkSiteEmployees = async (worksiteId) => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/employeedetailsbyworksite/${worksiteId}/`
      );
      const sortedList = customSortByKey(res.data, "emp_code");

      setWorkSiteEmployees(sortedList);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // useEffect(() => {
  //   getWorkSiteEmployees();
  // }, []);

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split('/');
  const url = urlParts[3]
  const Viewdetails = (emp_code, user_detail) => {
    navigate(`/${url}/userdetailscrud/${emp_code}/${user_detail}/`);
  };
  return (
    <>
      <button
        className=""
        title="View Employees"
        style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
        onClick={handleShow}
      >
        View
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <>
            {/* <div className="attendance-history-cont">
              <div className="attendance-heading  font-weight500    font-size-heading"></div>
            </div> */}
            <div className="table-css-white-background">
              <div className="table-heading-flex">
                <div className="repo-heading font-weight500    font-size-heading">
                  Employees in : <br /> {worksite.title}{" "}
                </div>
                <div className="flex-row">
                  <div className="table-searchh">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="11"
                        height="12"
                        viewBox="0 0 11 12"
                        fill="none"
                      >
                        <circle
                          cx="5"
                          cy="5"
                          r="4.3"
                          stroke="#2B3674"
                          strokeWidth="1.4"
                        />
                        <line
                          x1="10.0101"
                          y1="11"
                          x2="8"
                          y2="8.98995"
                          stroke="#2B3674"
                          strokeWidth="1.4"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <div>
                      <input
                        placeholder="Search"
                        className="navbar-inputt font-weight400  font-size-text"
                        value={searchQuery}
                        onChange={handleSearchChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left">ID</th>
                    <th className="align-center">Emp Code</th>
                    <th className="align-center"> Name </th>
                    <th className="align-center">Employee View</th>
                  </tr>
                </thead>
                {buffer ? <div className="spinner"></div> : //buffering logic
                  <tbody>
                    {worksiteEmployees
                      ?.filter(
                        (e) =>
                          e.name
                            .toLowerCase()
                            .includes(searchQuery.toLowerCase()) ||
                          e.emp_code
                            .toString()
                            .includes(searchQuery.toLowerCase())
                      )
                      .sort((a, b) => a.emp_code - b.emp_code)
                      .map((i, index) => (
                        <React.Fragment key={index}>
                          {/* <tr className="tr-border-bottom">
                          <td colSpan="6"></td>
                        </tr> */}
                          <tr className="custom-table-head-td">
                            <td className="align-left">{index + 1}</td>
                            <td className="align-center">{i.emp_code}</td>
                            <td className="align-center">{i.name}</td>

                            <td className="align-center">
                              <button
                                className="employee-edit"
                                onClick={() =>
                                  Viewdetails(i.emp_code, i.user_detail)
                                }
                                title="View Profile"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="40"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                >
                                  <circle cx="15" cy="15" r="15" fill="#F6F7F9" />
                                  <path
                                    d="M23.8913 14.5437C22.1966 11.2372 18.8416 9 15 9C11.1584 9 7.80249 11.2388 6.10873 14.5441C6.03725 14.6855 6 14.8417 6 15.0002C6 15.1586 6.03725 15.3148 6.10873 15.4563C7.80342 18.7628 11.1584 21 15 21C18.8416 21 22.1975 18.7612 23.8913 15.4559C23.9628 15.3145 24 15.1583 24 14.9998C24 14.8414 23.9628 14.6852 23.8913 14.5437ZM15 19.5C14.11 19.5 13.24 19.2361 12.4999 18.7416C11.7599 18.2471 11.1831 17.5443 10.8425 16.7221C10.5019 15.8998 10.4128 14.995 10.5865 14.1221C10.7601 13.2492 11.1887 12.4474 11.818 11.818C12.4474 11.1887 13.2492 10.7601 14.1221 10.5865C14.995 10.4128 15.8998 10.5019 16.7221 10.8425C17.5443 11.1831 18.2472 11.7599 18.7416 12.4999C19.2361 13.24 19.5 14.11 19.5 15C19.5003 15.591 19.3841 16.1763 19.1581 16.7224C18.932 17.2685 18.6005 17.7647 18.1826 18.1826C17.7647 18.6005 17.2685 18.932 16.7224 19.158C16.1763 19.3841 15.591 19.5003 15 19.5ZM15 12C14.7322 12.0037 14.4662 12.0436 14.2091 12.1184C14.421 12.4065 14.5227 12.7609 14.4957 13.1175C14.4688 13.4741 14.3149 13.8092 14.062 14.062C13.8092 14.3149 13.4741 14.4688 13.1175 14.4957C12.7609 14.5227 12.4065 14.421 12.1184 14.2091C11.9544 14.8133 11.984 15.4538 12.2031 16.0403C12.4221 16.6269 12.8196 17.1299 13.3396 17.4787C13.8595 17.8275 14.4758 18.0045 15.1016 17.9847C15.7274 17.965 16.3312 17.7495 16.8281 17.3685C17.325 16.9876 17.6899 16.4604 17.8715 15.8612C18.0531 15.2621 18.0422 14.621 17.8404 14.0283C17.6386 13.4356 17.256 12.9211 16.7465 12.5573C16.2369 12.1934 15.6261 11.9985 15 12Z"
                                    fill="#2576BC"
                                  />
                                </svg>
                              </button>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                }
              </table>
            </div>
          </>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const AttendancePolicyTable = () => {
  const [attpolicyname, setAttPolicyname] = useState([]);
  const { SUB_COMPANIES, SUPER_ADMIN, PERMISSION_AUTHORITY, PERMISSION_HR_ADMIN } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [buffer, setBuffering] = useState(true); //buffering logic


  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const getAttPolicyName = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(`${BASE_URL}/wfm/attendancepolicyfilterall/${toggleCompany}/active/`);
      setAttPolicyname(res.data);
    } catch (err) {
      //toast Logic
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getAttPolicyName();
  }, [toggleCompany]);

  return (
    <div className="table-css-white-background">
      <div className="table-heading-flex">
        <div className="repo-heading font-weight500    font-size-heading">Attendance Policy</div>
        <div className="field-cont">

          {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div">
            <Office />
            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
              <option value="null">Select Sub Company</option>
              {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

            </select>
          </div> : null
          }
          <div className="table-searchh field-cont-div">
            <div>
              <SearchBig />
              <input
                placeholder="Search"
                className="navbar-inputt font-weight400  font-size-text"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <AttendancePolicyAdd getAttPolicyList={getAttPolicyName} SUB_COMPANIES={SUB_COMPANIES} PERMISSION_AUTHORITY={PERMISSION_AUTHORITY} />
        </div>
      </div>
      <table className="table-css">
        <thead>
          <tr className="custom-table-head-tr">
            <th className="align-left">ID</th>
            <th className="align-center">Name</th>
            <th className="align-center">Company</th>
            <th className="align-center">Employee Count</th>
            <th className="align-center">Updated at</th>
            <th className="align-center">Updated by</th>
            <th className="align-center">Employee View</th>
            <th className="align-right width-10vw">Action</th>
          </tr>
        </thead>
        {buffer ? <div className="spinner"></div> : //buffering logic
          <tbody>
            {attpolicyname
              ?.filter((e) =>
                e.name.toLowerCase().includes(searchQuery.toLowerCase())
              )
              .sort((a, b) =>
                a.name.localeCompare(b.name, "en", { ignorePunctuation: true })
              )
              .map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="tr-border-bottom">
                    <td colSpan="6"></td>
                  </tr>
                  <tr className="custom-table-head-td">
                    <td className="align-left">{index + 1}</td>
                    <td className="align-center">{i.name}</td>
                    <td className="align-center">{i.sub_company_title}</td>
                    <td className="align-center">{i?.active_count}</td>
                    <td className="align-center">
                      {formatDateTime(i.updated_at).shortfull}
                    </td>

                    <td className="align-center">
                      {i.updated_by &&
                        <CustomImageModal customStyle>
                          {i.updated_by_profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.updated_by_profilepic}`}
                              className="profile-img"
                              alt={i?.updated_by_name}
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{ name: i.updated_by_name, profilepic: '' }} customStyleforParent={"reqOutDuty-default-logo"} customStyleforChild={'small-profile'}
                            />
                          )}
                        </CustomImageModal>
                      }
                      <p> {i.updated_by && `${i.updated_by} - `}{i.updated_by_name}</p>
                    </td>
                    <td className="align-center">
                      <EmployeebyAttendancePolicyTable policy={i} />
                    </td>
                    <td className="align-right width-5vw ">
                      {PERMISSION_HR_ADMIN && (
                        <AttendancePolicyUpdate
                          i={i}
                          getAttPolicyList={getAttPolicyName}
                          SUB_COMPANIES={SUB_COMPANIES}
                          PERMISSION_AUTHORITY={PERMISSION_AUTHORITY}
                        />
                      )}
                      {PERMISSION_AUTHORITY && i?.total_employee_count == 0 && (
                        <AttendancePolicyDelete
                          i={i}
                          getAttPolicyList={getAttPolicyName}
                        />
                      )}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        }
      </table>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};

const EmployeebyAttendancePolicyTable = ({ policy }) => {
  const [show, setShow] = useState(false);
  const [buffer, setBuffering] = useState(true); //buffering logic

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    getAttendancePolicyEmployees(policy.id);
  };
  const [attendancePolicyEmployees, setAttendancePolicyEmployees] = useState(
    []
  );

  const getAttendancePolicyEmployees = async (policyId) => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/employeedetailsbyattendancepolicy/${policyId}/`
      );
      const sortedList = customSortByKey(res.data, "emp_code");

      setAttendancePolicyEmployees(sortedList);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split('/');
  const url = urlParts[3]
  const Viewdetails = (emp_code, user_detail) => {
    navigate(`/${url}/userdetailscrud/${emp_code}/${user_detail}/`);
  };
  return (
    <>
      <button
        className=""
        title="View Employees"
        style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
        onClick={handleShow}
      >
        View
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <>
            {/* <div className="attendance-history-cont">
              <div className="attendance-heading  font-weight500    font-size-heading"></div>
            </div> */}
            <div className="table-css-white-background">
              <div className="table-heading-flex">
                <div className="repo-heading font-weight500    font-size-heading">
                  Employees with : <br /> {policy.name} Policy
                </div>
                <div className="flex-row">
                  <div className="table-searchh">
                    <SearchBig />
                    <div>
                      <input
                        placeholder="Search"
                        className="navbar-inputt font-weight400  font-size-text"
                        value={searchQuery}
                        onChange={handleSearchChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left">ID</th>
                    <th className="align-center">Emp Code</th>
                    <th className="align-center"> Name </th>
                    <th className="align-center">Employee View</th>
                  </tr>
                </thead>
                {buffer ? <div className="spinner"></div> : //buffering logic
                  <tbody>
                    {attendancePolicyEmployees
                      ?.filter(
                        (e) =>
                          e.name
                            .toLowerCase()
                            .includes(searchQuery.toLowerCase()) ||
                          e.emp_code
                            .toString()
                            .includes(searchQuery.toLowerCase())
                      )
                      .sort((a, b) => a.emp_code - b.emp_code)
                      .map((i, index) => (
                        <React.Fragment key={index}>
                          {/* <tr className="tr-border-bottom">
                          <td colSpan="6"></td>
                        </tr> */}
                          <tr className="custom-table-head-td">
                            <td className="align-left">{index + 1}</td>
                            <td className="align-center">{i.emp_code}</td>
                            <td className="align-center">{i.name}</td>
                            <td className="align-center">
                              <button
                                className="employee-edit"
                                onClick={() =>
                                  Viewdetails(i.emp_code, i.user_detail)
                                }
                                title="View Profile"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="40"
                                  height="40"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                >
                                  <circle cx="15" cy="15" r="15" fill="#F6F7F9" />
                                  <path
                                    d="M23.8913 14.5437C22.1966 11.2372 18.8416 9 15 9C11.1584 9 7.80249 11.2388 6.10873 14.5441C6.03725 14.6855 6 14.8417 6 15.0002C6 15.1586 6.03725 15.3148 6.10873 15.4563C7.80342 18.7628 11.1584 21 15 21C18.8416 21 22.1975 18.7612 23.8913 15.4559C23.9628 15.3145 24 15.1583 24 14.9998C24 14.8414 23.9628 14.6852 23.8913 14.5437ZM15 19.5C14.11 19.5 13.24 19.2361 12.4999 18.7416C11.7599 18.2471 11.1831 17.5443 10.8425 16.7221C10.5019 15.8998 10.4128 14.995 10.5865 14.1221C10.7601 13.2492 11.1887 12.4474 11.818 11.818C12.4474 11.1887 13.2492 10.7601 14.1221 10.5865C14.995 10.4128 15.8998 10.5019 16.7221 10.8425C17.5443 11.1831 18.2472 11.7599 18.7416 12.4999C19.2361 13.24 19.5 14.11 19.5 15C19.5003 15.591 19.3841 16.1763 19.1581 16.7224C18.932 17.2685 18.6005 17.7647 18.1826 18.1826C17.7647 18.6005 17.2685 18.932 16.7224 19.158C16.1763 19.3841 15.591 19.5003 15 19.5ZM15 12C14.7322 12.0037 14.4662 12.0436 14.2091 12.1184C14.421 12.4065 14.5227 12.7609 14.4957 13.1175C14.4688 13.4741 14.3149 13.8092 14.062 14.062C13.8092 14.3149 13.4741 14.4688 13.1175 14.4957C12.7609 14.5227 12.4065 14.421 12.1184 14.2091C11.9544 14.8133 11.984 15.4538 12.2031 16.0403C12.4221 16.6269 12.8196 17.1299 13.3396 17.4787C13.8595 17.8275 14.4758 18.0045 15.1016 17.9847C15.7274 17.965 16.3312 17.7495 16.8281 17.3685C17.325 16.9876 17.6899 16.4604 17.8715 15.8612C18.0531 15.2621 18.0422 14.621 17.8404 14.0283C17.6386 13.4356 17.256 12.9211 16.7465 12.5573C16.2369 12.1934 15.6261 11.9985 15 12Z"
                                    fill="#2576BC"
                                  />
                                </svg>
                              </button>
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                  </tbody>
                }
              </table>
            </div>
          </>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const WeeklyOffPolicyTable = () => {
  const [WeeklyOffpolicyname, setWeeklyOffPolicyname] = useState([]);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY, SUPER_ADMIN, PERMISSION_HR_ADMIN } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [buffer, setBuffering] = useState(true); //buffering logic

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const getWeeklyOffPolicyName = async (PERMISSION_AUTHORITY) => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(
        PERMISSION_AUTHORITY ?
          `${BASE_URL}/wfm/weeklyoffpolicyfilterall/${toggleCompany}/active/`
          :
          `${BASE_URL}/wfm/weeklyoffpolicyfilterall/${sessionStorage.getItem(
            "company_id"
          )}/active/`
      );
      // const res = await axios.get(`${BASE_URL}/wfm/weeklyoffPolicy/`);
      setWeeklyOffPolicyname(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getWeeklyOffPolicyName(PERMISSION_AUTHORITY);
  }, [toggleCompany]);

  return (
    <div className="table-css-white-background">
      <div className="table-heading-flex">
        <div className="repo-heading font-weight500    font-size-heading">Weekly Off Policy</div>
        <div className="field-cont">
          {PERMISSION_AUTHORITY ? <div className="table-searchh dropdown-container field-cont-div">
            <Office />
            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
              <option value="null">Select Sub Company</option>
              {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

            </select>
          </div> : null
          }          <div className="table-searchh">
            <div>
              <SearchBig />
              <input
                placeholder="Search"
                className="navbar-inputt font-weight400  font-size-text"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <AddWeeklyOffPolicy getWeeklyOffPolicyName={getWeeklyOffPolicyName} />
        </div>
      </div>
      <table className="table-css">
        <thead>
          <tr className="custom-table-head-tr">
            <th className="align-left">ID</th>
            <th className="align-center">Name</th>
            <th className="align-center">Company</th>
            <th className="align-center">Employee Count</th>
            <th className="align-center">Updated at</th>
            <th className="align-center">Updated by</th>
            <th className="align-center">Employee View</th>
            <th className="align-right width-10vw">Action</th>
          </tr>
        </thead>
        {buffer ? <div className="spinner"></div> : //buffering logic
          <tbody>
            {WeeklyOffpolicyname?.filter((e) =>
              e.name.toLowerCase().includes(searchQuery.toLowerCase())
            )
              .sort((a, b) =>
                a.name.localeCompare(b.name, "en", { ignorePunctuation: true })
              )
              .map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="tr-border-bottom">
                    <td colSpan="6"></td>
                  </tr>
                  <tr className="custom-table-head-td">
                    <td className="align-left">{index + 1}</td>
                    <td className="align-center">{i.name}</td>
                    <td className="align-center">{i.sub_company_title}</td>
                    <td className="align-center">{i?.active_count}</td>
                    <td className="align-center">
                      {formatDateTime(i.updated_at).shortfull}
                    </td>

                    <td className="align-center">
                      {i.updated_by &&
                        <CustomImageModal customStyle>
                          {i.updated_by_profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.updated_by_profilepic}`}
                              className="profile-img"
                              alt={i?.updated_by_name}
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{ name: i.updated_by_name, profilepic: '' }} customStyleforParent={"reqOutDuty-default-logo"} customStyleforChild={'small-profile'}
                            />
                          )}
                        </CustomImageModal>
                      }
                      <p> {i.updated_by && `${i.updated_by} - `}{i.updated_by_name}</p>
                    </td>
                    <td className="align-center">
                      <EmployeebyWeeklyOffPolicyTable policy={i} />
                    </td>
                    <td className="align-right width-5vw ">
                      {PERMISSION_HR_ADMIN && (
                        <UpdateWeeklyOffPolicy
                          i={i}
                          getWeeklyOffPolicyName={getWeeklyOffPolicyName}
                        />
                      )}
                      {PERMISSION_AUTHORITY && i?.total_employee_count == 0 && (
                        <WeeklyOffPolicyDelete
                          i={i}
                          getWeeklyOffPolicyName={getWeeklyOffPolicyName}
                        />
                      )}


                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        }
      </table>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};

const EmployeebyWeeklyOffPolicyTable = ({ policy }) => {
  const [show, setShow] = useState(false);
  const [buffer, setBuffering] = useState(true); //buffering logic

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    getWeeklyOffPolicyEmployees(policy.id);
  };
  const [weekOffPolicyEmployees, setWeekOffPolicyEmployees] = useState([]);

  const getWeeklyOffPolicyEmployees = async (policyId) => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/employeedetailsbyweeklyoffpolicy/${policyId}/`
      );
      const sortedList = customSortByKey(res.data, "emp_code");

      setWeekOffPolicyEmployees(sortedList);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // useEffect(() => {
  //   getWeeklyOffPolicyEmployees();
  // }, []);

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split('/');
  const url = urlParts[3]
  const Viewdetails = (emp_code, user_detail) => {
    navigate(`/${url}/userdetailscrud/${emp_code}/${user_detail}/`);
  };
  return (
    <>
      <button
        className=""
        title="View Employees List"
        style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
        onClick={handleShow}
      >
        View
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <>
            {/* <div className="attendance-history-cont">
              <div className="attendance-heading  font-weight500    font-size-heading"></div>
            </div> */}
            <div className="table-css-white-background">
              <div className="table-heading-flex">
                <div className="repo-heading font-weight500    font-size-heading">
                  Employees with : <br /> {policy.name} Policy
                </div>
                <div className="flex-row">
                  <div className="table-searchh">
                    <div>
                      <SearchBig />

                    </div>
                    <div>
                      <input
                        placeholder="Search"
                        className="navbar-inputt font-weight400  font-size-text"
                        value={searchQuery}
                        onChange={handleSearchChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left">ID</th>
                    <th className="align-center">Emp Code</th>
                    <th className="align-center"> Name </th>
                    <th className="align-center">Employee View</th>
                  </tr>
                </thead>
                <tbody>
                  {weekOffPolicyEmployees
                    ?.filter(
                      (e) =>
                        e.name
                          .toLowerCase()
                          .includes(searchQuery.toLowerCase()) ||
                        e.emp_code
                          .toString()
                          .includes(searchQuery.toLowerCase())
                    )
                    .sort((a, b) => a.emp_code - b.emp_code)
                    .map((i, index) => (
                      <React.Fragment key={index}>
                        {/* <tr className="tr-border-bottom">
                          <td colSpan="6"></td>
                        </tr> */}
                        <tr className="custom-table-head-td">
                          <td className="align-left">{index + 1}</td>
                          <td className="align-center">{i.emp_code}</td>
                          <td className="align-center">{i.name}</td>
                          <td className="align-center">
                            <button
                              className="employee-edit"
                              onClick={() =>
                                Viewdetails(i.emp_code, i.user_detail)
                              }
                              title="View Profile"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="40"
                                height="40"
                                viewBox="0 0 30 30"
                                fill="none"
                              >
                                <circle cx="15" cy="15" r="15" fill="#F6F7F9" />
                                <path
                                  d="M23.8913 14.5437C22.1966 11.2372 18.8416 9 15 9C11.1584 9 7.80249 11.2388 6.10873 14.5441C6.03725 14.6855 6 14.8417 6 15.0002C6 15.1586 6.03725 15.3148 6.10873 15.4563C7.80342 18.7628 11.1584 21 15 21C18.8416 21 22.1975 18.7612 23.8913 15.4559C23.9628 15.3145 24 15.1583 24 14.9998C24 14.8414 23.9628 14.6852 23.8913 14.5437ZM15 19.5C14.11 19.5 13.24 19.2361 12.4999 18.7416C11.7599 18.2471 11.1831 17.5443 10.8425 16.7221C10.5019 15.8998 10.4128 14.995 10.5865 14.1221C10.7601 13.2492 11.1887 12.4474 11.818 11.818C12.4474 11.1887 13.2492 10.7601 14.1221 10.5865C14.995 10.4128 15.8998 10.5019 16.7221 10.8425C17.5443 11.1831 18.2472 11.7599 18.7416 12.4999C19.2361 13.24 19.5 14.11 19.5 15C19.5003 15.591 19.3841 16.1763 19.1581 16.7224C18.932 17.2685 18.6005 17.7647 18.1826 18.1826C17.7647 18.6005 17.2685 18.932 16.7224 19.158C16.1763 19.3841 15.591 19.5003 15 19.5ZM15 12C14.7322 12.0037 14.4662 12.0436 14.2091 12.1184C14.421 12.4065 14.5227 12.7609 14.4957 13.1175C14.4688 13.4741 14.3149 13.8092 14.062 14.062C13.8092 14.3149 13.4741 14.4688 13.1175 14.4957C12.7609 14.5227 12.4065 14.421 12.1184 14.2091C11.9544 14.8133 11.984 15.4538 12.2031 16.0403C12.4221 16.6269 12.8196 17.1299 13.3396 17.4787C13.8595 17.8275 14.4758 18.0045 15.1016 17.9847C15.7274 17.965 16.3312 17.7495 16.8281 17.3685C17.325 16.9876 17.6899 16.4604 17.8715 15.8612C18.0531 15.2621 18.0422 14.621 17.8404 14.0283C17.6386 13.4356 17.256 12.9211 16.7465 12.5573C16.2369 12.1934 15.6261 11.9985 15 12Z"
                                  fill="#2576BC"
                                />
                              </svg>
                            </button>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                </tbody>
              </table>
            </div>
          </>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};


const SalaryStructureHeadingTable = () => {
  const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY, SUPER_ADMIN } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [buffer, setBuffering] = useState(true); //buffering logic

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const getSalaryStructureHeadings = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(`${BASE_URL}/wfm/salaryHeadingbysubcompany/${toggleCompany}/`);
      setSalaryStructureHeadings(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getSalaryStructureHeadings();
  }, [toggleCompany]);

  return (
    <div className="table-css-white-background">
      <div className="table-heading-flex">
        <div className="repo-heading font-weight500    font-size-heading">Salary Structure Headings</div>
        <div className="field-cont">
          {PERMISSION_AUTHORITY ? <div className="table-searchh dropdown-container field-cont-div">
            <Office />
            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
              <option value="null">Select SubCompany</option>
              {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

            </select>
          </div> : null
          }
          <div className="table-searchh">
            <div>
              <SearchSmall />
              <input
                placeholder="Search"
                className="navbar-inputt font-weight400  font-size-text"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <SalaryStructureHeadingAdd
            salaryStructureHeadings={salaryStructureHeadings}
            getSalaryStructureHeadings={getSalaryStructureHeadings}
            SUB_COMPANIES={SUB_COMPANIES}
            PERMISSION_AUTHORITY={PERMISSION_AUTHORITY}
          />
        </div>
      </div>
      <table className="table-css">
        <thead>
          <tr className="custom-table-head-tr">
            <th className="align-left">Sr. No.</th>
            <th className="align-center">Position No.</th>
            <th className="align-center">Name</th>
            <th className="align-center">Type</th>
            <th className="align-center">Last Update</th>
            <th className="align-right">Company</th>
            <th className="align-right width-10vw">Action</th>
          </tr>
        </thead>
        {buffer ? <div className="spinner"></div> : //buffering logic
          <tbody>
            {salaryStructureHeadings?.filter((e) =>
              e.title.toLowerCase().includes(searchQuery.toLowerCase())
            )
              .sort((a, b) => a.sorting_var - b.sorting_var)
              .map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="tr-border-bottom">
                    <td colSpan="6"></td>
                  </tr>
                  <tr className="custom-table-head-td">
                    <td className="align-left">{index + 1}</td>
                    <td className="align-center">{i.sorting_var}</td>
                    <td className="align-center">{i.title}</td>
                    <td className="align-center text-capitalize">{i.salary_type}</td>

                    <td className="align-center">
                      <>
                        {i.updated_by &&
                          <>
                            <CustomImageModal customStyle>
                              {i.updated_by_profilepic ? (
                                <img
                                  src={`${`${IMAGE_URL}${i.updated_by_profilepic}`}`}
                                  alt="profile" className="profile-img"
                                />
                              ) : (
                                <UserDefaultLogo user={{ name: i.updated_by_name, profilepic: i.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                              )}
                            </CustomImageModal>
                            <p>{`${i.updated_by} - `}{i.updated_by_name}</p>
                            {/* At- */}
                          </>
                        }
                        <small>{i?.updated_at && formatDateTime(i?.updated_at).shortfull}</small>
                      </>
                    </td>

                    <td className="align-right">{i.sub_company_title}</td>
                    <td className="align-right width-5vw ">
                      {PERMISSION_AUTHORITY &&
                        <SalaryStructureHeadingUpdate
                          i={i}
                          salaryStructureHeadings={salaryStructureHeadings}
                          getSalaryStructureHeadings={getSalaryStructureHeadings}
                          SUB_COMPANIES={SUB_COMPANIES}
                          PERMISSION_AUTHORITY={PERMISSION_AUTHORITY}
                        />
                      }
                      {/* <SalaryStructureHeadingDelete
                        i={i}
                        getSalaryStructureHeadings={getSalaryStructureHeadings}
                      /> */}
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        }
      </table>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};

const SalaryStructureFormatTable = () => {
  const [salaryDeductionPolicies, setSalaryDeductionPolicy] = useState([]);
  const { SUB_COMPANIES, SUPER_ADMIN, PERMISSION_AUTHORITY } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [buffer, setBuffering] = useState(true); //buffering logic

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const getSalaryStructureFormat = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(`${BASE_URL}/wfm/salarypolicybysubcompany/${toggleCompany}/`);
      setSalaryDeductionPolicy(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getSalaryStructureFormat();
  }, [toggleCompany]);

  return (
    <div className="table-css-white-background">
      <div className="table-heading-flex">
        <div className="repo-heading font-weight500    font-size-heading">Salary Structure Format</div>
        <div className="field-cont">
          {SUPER_ADMIN ? <div className="table-searchh dropdown-container field-cont-div">
            <Office />
            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
              <option value="null">Select SubCompany</option>
              {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
            </select>
          </div> : null
          }
          <div className="table-searchh">
            <div>
              <SearchSmall />
              <input
                placeholder="Search"
                className="navbar-inputt font-weight400  font-size-text"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <AddSalaryStructurePolicyFormat getSalaryStructureFormat={getSalaryStructureFormat} />
        </div>
      </div>
      <table className="table-css">
        <thead>
          <tr className="custom-table-head-tr">
            <th className="align-left">Sr. No.</th>
            <th className="align-center">Company</th>
            <th className="align-center">Name</th>
            <th className="align-center">Updated at</th>
            <th className="align-center">Updated by</th>
            <th className="align-center">View Format</th>
            <th className="align-right width-10vw">Action</th>
          </tr>
        </thead>
        {buffer ? <div className="spinner"></div> : //buffering logic
          <tbody>
            {salaryDeductionPolicies?.filter((e) =>
              e.policy_name?.toLowerCase().includes(searchQuery.toLowerCase())
            )
              .sort((a, b) =>
                a.policy_name?.localeCompare(b.policy_name, "en", { ignorePunctuation: true })
              )
              .map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="tr-border-bottom">
                    <td colSpan="6"></td>
                  </tr>
                  <tr className="custom-table-head-td">
                    <td className="align-left">{index + 1}</td>
                    <td className="align-center">{i.sub_company_title}</td>
                    <td className="align-center">{i.policy_name}</td>
                    <td className="align-center">
                      {formatDateTime(i.updated_at).shortfull}
                    </td>

                    <td className="align-center">
                      {i.updated_by &&
                        <CustomImageModal customStyle>
                          {i.updated_by_profilepic ? (
                            <img
                              src={`${IMAGE_URL}${i.updated_by_profilepic}`}
                              className="profile-img"
                              alt={i?.updated_by_name}
                            />
                          ) : (
                            <UserDefaultLogo
                              user={{ name: i.updated_by_name, profilepic: '' }} customStyleforParent={"reqOutDuty-default-logo"} customStyleforChild={'small-profile'}
                            />
                          )}
                        </CustomImageModal>
                      }
                      <p> {i.updated_by && `${i.updated_by} - `}{i.updated_by_name}</p>
                    </td>
                    <td className="align-center">
                      <ViewSalaryPolicyFormatDeductions i={i} getSalaryStructureFormat={getSalaryStructureFormat} actionButtons={true} />
                    </td>
                    <td className="align-right width-5vw ">
                      {PERMISSION_AUTHORITY &&
                        <DeleteSalaryStructurePolicyFormat
                          i={i}
                          getSalaryStructureFormat={getSalaryStructureFormat}
                        />
                      }
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        }
      </table>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};

const SalaryCalculationPolicyTable = () => {
  const [salaryCalculationPolicies, setSalaryCalculationPolicy] = useState([]);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [buffer, setBuffering] = useState(true); //buffering logic

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const getSalaryCalculationPolicyList = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(`${BASE_URL}/wfm/salarypolicybysubcompany/${toggleCompany}/`);
      setSalaryCalculationPolicy(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getSalaryCalculationPolicyList();
  }, [toggleCompany]);

  return (
    <div className="table-css-white-background">
      <div className="table-heading-flex">
        <div className="repo-heading font-weight500    font-size-heading">Salary Calculation Policies</div>
        <div className="field-cont">
          {PERMISSION_AUTHORITY ? <div className="table-searchh dropdown-container field-cont-div">
            <Office />
            <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
              <option value="null">Select SubCompany</option>
              {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

            </select>
          </div> : null
          }
          <div className="table-searchh">
            <div>
              <SearchSmall />
              <input
                placeholder="Search"
                className="navbar-inputt font-weight400  font-size-text"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <SalaryCalculationPolicyAdd getSalaryCalculationPolicyList={getSalaryCalculationPolicyList} />
        </div>
      </div>
      <table className="table-css">
        <thead>
          <tr className="custom-table-head-tr">
            <th className="align-left">Sr. No.</th>
            <th className="align-center">Company</th>
            <th className="align-center">Name</th>
            <th className="align-right width-10vw">Action</th>
          </tr>
        </thead>
        {buffer ? <div className="spinner"></div> : //buffering logic
          <tbody>
            {salaryCalculationPolicies?.filter((e) =>
              e?.policy_name?.toLowerCase().includes(searchQuery.toLowerCase())
            )
              .sort((a, b) =>
                a?.name?.localeCompare(b?.name, "en", { ignorePunctuation: true })
              )
              .map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="tr-border-bottom">
                    <td colSpan="6"></td>
                  </tr>
                  <tr className="custom-table-head-td">
                    <td className="align-left">{index + 1}</td>
                    <td className="align-center">{i.sub_company_title}</td>
                    <td className="align-center">{i.policy_name}</td>
                    <td className="align-right width-5vw ">
                      <SalaryCalculationPolicyUpdate
                        i={i}
                        getSalaryCalculationPolicyList={getSalaryCalculationPolicyList}
                      />
                      <SalaryCalculationPolicyDelete
                        i={i}
                        getSalaryCalculationPolicyList={getSalaryCalculationPolicyList}
                      />
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        }
      </table>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};


const CalenderTable = () => {
  const [calendername, setCalendername] = useState([]);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [buffer, setBuffering] = useState(true); //buffering logic

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const getcalender = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(PERMISSION_AUTHORITY ?
        `${BASE_URL}/wfm/calenderfilterbysubcompany/${toggleCompany}/`
        :
        `${BASE_URL}/wfm/calenderfilterbysubcompany/${sessionStorage.getItem(
          "company_id"
        )}/`
      );
      // const res = await axios.get(`${BASE_URL}/wfm/calander/`);
      setCalendername(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getcalender();
  }, [toggleCompany]);

  return (
    <>
      <div className="table-css-white-background">
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500    font-size-heading">Calender </div>
          <div className="field-cont">
            {PERMISSION_AUTHORITY ? <div className="table-searchh dropdown-container field-cont-div">
              <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                <option value="null">Select Sub Company</option>
                {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

              </select>
            </div> : null
            }
            <div className="table-searchh">
              <div>
                <SearchSmall />
              </div>
              <div>
                <input
                  placeholder="Search"
                  className="navbar-inputt font-weight400  font-size-text"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  type="date"
                />
              </div>
            </div>
            <CalenderAdd getcalender={getcalender} />
          </div>
        </div>
        <table className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">Sr.no</th>
              <th className="align-center">Company</th>
              <th className="align-center">Date</th>
              <th className="align-center">Description</th>
              <th className="align-center">Updated at</th>
              <th className="align-center">Updated by</th>
              <th className="align-center">Type</th>
              <th className="align-right width-10vw">Action</th>
            </tr>
          </thead>
          {buffer ? <div className="spinner"></div> : //buffering logic
            <tbody>
              {calendername
                ?.filter((e) =>
                  e.date.toLowerCase().includes(searchQuery.toLowerCase())
                )
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{index + 1}</td>
                      <td className="align-center">{i.sub_company_title}</td>
                      <td className="align-center">
                        {formattedDateLong(i.date)}
                      </td>

                      <td className="align-center">{i.descritpion}</td>
                      <td className="align-center">
                        {formatDateTime(i.updated_at).shortfull}
                      </td>

                      <td className="align-center">
                        {i.updated_by &&
                          <CustomImageModal customStyle>
                            {i.updated_by_profilepic ? (
                              <img
                                src={`${IMAGE_URL}${i.updated_by_profilepic}`}
                                className="profile-img"
                                alt={i?.updated_by_name}
                              />
                            ) : (
                              <UserDefaultLogo
                                user={{ name: i.updated_by_name, profilepic: '' }} customStyleforParent={"reqOutDuty-default-logo"} customStyleforChild={'small-profile'}
                              />
                            )}
                          </CustomImageModal>
                        }
                        <p> {i.updated_by && `${i.updated_by} - `}{i.updated_by_name}</p>
                      </td>
                      <td className="align-center text-capitalize">
                        {i.offtype}
                      </td>
                      <td className="align-right width-5vw ">
                        <CalenderUpdate i={i} getcalender={getcalender} />
                        {PERMISSION_AUTHORITY &&
                          <CalenderDelete i={i} getcalender={getcalender} />
                        }
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
            </tbody>
          }
        </table>
      </div>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};

const TlCalenderTable = () => {
  const [calendername, setCalendername] = useState([]);
  const [buffer, setBuffering] = useState(true); //buffering logic

  const getcalender = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/calenderfilterbysubcompany/${sessionStorage.getItem(
          "company_id"
        )}/`
      );
      setCalendername(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getcalender();
  }, []);

  return (
    <>
      <div className="table-css-white-background">
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500    font-size-heading">Calender </div>
          <div>{/* <CalenderAdd getcalender={getcalender} /> */}</div>
        </div>
        <table className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">Sr.no</th>
              <th className="align-center">Company</th>
              <th className="align-center">Date</th>
              <th className="align-center">Description</th>
              <th className="align-center">Type</th>
            </tr>
          </thead>
          {buffer ? <div className="spinner"></div> : //buffering logic
            <tbody>
              {calendername
                .sort((a, b) => new Date(a.date) - new Date(b.date))
                .map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{index + 1}</td>
                      <td className="align-center">{i.sub_company_title}</td>
                      <td className="align-center">
                        {formattedDateLong(i.date)}
                      </td>
                      <td className="align-right width-10vw text-capitalize">
                        {i.offtype}
                      </td>
                      <td className="align-center">{i.descritpion}</td>
                    </tr>
                  </React.Fragment>
                ))}
            </tbody>
          }
        </table>
      </div>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};

const InterComTable = () => {

  const { SUB_COMPANIES, SUPER_ADMIN, PERMISSION_AUTHORITY } = usePermission();

  const [buffer, setBuffering] = useState(true); //buffering logic
  const [buffer1, setBuffering1] = useState(true); //buffering logic
  const [buffer2, setBuffering2] = useState(true); //buffering logic

  const [interCom, setInterCom] = useState([]);
  const [filteredInterCom, setFilteredInterCom] = useState([]);

  const [departmentList, setDepartmentList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [empList, setEmpList] = useState([])

  const [searchVariable, setSearchVariable] = useState("");
  const [selectedDesignation, setDesignation] = useState('');

  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
  const [active, setActive] = useState("active");
  const [selectedDepartment, setDepartment] = useState('null');
  const [selectedEmployee, setEmployee] = useState('null');

  const [searchQuery, setSearchQuery] = useState("");
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };


  const getAllEmp_code = async () => {
    setBuffering1(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/wfm/ourcompanyempdetails/${active}/${toggleCompany}/`);
      const sortedList = customSortByKey(res.data, "emp_code");
      setEmpList(sortedList);
    } catch (err) {
      //toast Logic
      handleErrorToast(err)
    } finally {
      setBuffering1(false);// End Buffering
    }
  };
  const getDepartmentAndDesignation = async () => {
    setBuffering2(true);
    try {
      const des = await axios.get(
        `${BASE_URL}/wfm/designationfilterbysubcompanycount/${toggleCompany}/${active}/`
      );
      setDesignationList(des.data);

      const dep = await axios.get(
        `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${toggleCompany}/${active}/`
      );
      setDepartmentList(dep.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering2(false);// End Buffering
    }
  };


  const getIntercomData = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(
        // `${BASE_URL}/wfm/intercomfilterbysubcompany/${toggleCompany}/`
        `${BASE_URL}/wfm/intercom-by-filters/${toggleCompany}/${selectedDepartment}/${active}/${selectedEmployee}/`
      );
      const sortedList = customSortByKey(res.data, "user_detail");
      setInterCom(sortedList)
      setFilteredInterCom(sortedList);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };


  useEffect(() => {
    getDepartmentAndDesignation();
    getAllEmp_code();
  }, [toggleCompany, active]);

  useEffect(() => {
    getIntercomData();
  }, [toggleCompany, active, selectedDepartment, selectedEmployee]);


  const handleSearch = () => {
    let filteredData = interCom;

    // Filter by email or phone
    if (searchVariable) {
      const lowercaseSelectedName = searchVariable.toLowerCase();
      filteredData = filteredData.filter((employee) => {
        const emailMatch = String(employee.work_email || '')
          .toLowerCase()
          .includes(lowercaseSelectedName);

        const phoneMatchh = String(employee.contactno || '')
          .toLowerCase()
          .includes(lowercaseSelectedName);

        return emailMatch || phoneMatchh;
      });
    }

    if (selectedDesignation) {
      filteredData = filteredData.filter((desig) => {
        return String(desig.designation) === selectedDesignation;
      });
    }

    setFilteredInterCom(filteredData);
  };





  useEffect(() => {
    handleSearch();
  }, [
    interCom,
    searchVariable,
    selectedDesignation
  ]);


  const options = empList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map((i) => ({
      value: i.emp_code,
      label: `${i.emp_code} - ${i.name}`,
    }));

  const nullOption = { value: 'null', label: 'Select Employee Code' };

  const handleChange = (selectedOption) => {
    if (selectedOption) {
      setEmployee(selectedOption.value);
    } else {
      setEmployee('null'); // Clear selection
    }
  };


  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

      <div className="content-tabs">
        <div className="field-parent-cont">
          <div className="field-cont">

            {SUPER_ADMIN &&
              <>
                <div className="table-searchh dropdown-container field-cont-div">
                  <select
                    onChange={(e) => setToggleCompany(e.target.value)}
                    value={toggleCompany}
                    className="dropdown font-size-subheading"
                  >
                    <option value="">Select Sub Company</option>
                    {SUB_COMPANIES.map(company => (
                      <option key={company.id} value={company.id}>
                        {company.title}
                      </option>
                    ))}
                  </select>
                </div>
                <hr className="field-cont-hr" />
              </>
            }


            <div className="field-cont-div">
              <>
                {buffer1 ?
                  <div className="spinner-vsmall"></div>
                  :
                  <Employee />
                }
                <Select
                  className="attendance-input-field width-20vw"
                  width="200px"
                  options={[nullOption, ...options]}
                  value={options.find(option => option.value === selectedEmployee) || nullOption}
                  placeholder="Select Employee Code"
                  onChange={handleChange}
                  isClearable
                  style={{ CSSForFilterDropdown }}
                />
              </>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div-svg">
              <SearchBig />
              <input
                className="attendance-input-field width-16vw  "
                placeholder="By Email & Phone no"
                type="text"
                value={searchVariable}
                onChange={(e) => setSearchVariable(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              <Active />
              <select
                className="attendance-input-field width-10vw  "
                type="text"
                value={active}
                onChange={(e) => {
                  setActive(e.target.value)
                }}
              >
                <option value="null">All</option>
                <option value="active">Active</option>
                <option value="inactive">In Active</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div-svg">
              <SearchBig />
              <input
                placeholder="By Extension No."
                className="attendance-input-field width-10vw  "
                value={searchQuery}
                min={0}
                onChange={handleSearchChange}
                type="number"
              />
              <hr className="field-cont-hr" />
            </div>
            <div className="field-cont-div">
              {buffer2 ?
                <div className="spinner-vsmall"></div>
                :
                <CircularGrid />
              }
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDepartment}
                onChange={(e) => setDepartment(e.target.value)}
              >
                <option value="">All Department</option>
                {departmentList
                  .sort((a, b) => a.title - b.title)
                  .map((i, index) => (
                    <option value={i.id}>{i.title}</option>
                  ))};
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div">
              {buffer2 ?
                <div className="spinner-vsmall"></div>
                :
                <CircularGrid />
              }
              <select
                className="attendance-input-field width-10vw   date-field"
                type="text"
                value={selectedDesignation}
                onChange={(e) => setDesignation(e.target.value)}
              >
                <option value="">All Designation</option>
                {designationList
                  .sort((a, b) => a.title - b.title)
                  .map((i, index) => (
                    <option value={i.title}>{i.title}</option>
                  ))};
              </select>
              <hr className="field-cont-hr" />
            </div>
          </div>
          <div className="btn-cont">
            <InterCom getintercom={getIntercomData} employeeList={empList} />
          </div>
        </div>

        <div className="table-css-white-background">
          <div className="table-heading-flex">
            <div className="repo-heading font-weight500    font-size-heading">InterCom </div>

          </div>
          <table className="table-css">
            <thead>
              <tr className="custom-table-head-tr">
                <th className="align-left">Sr.no</th>
                <th className="align-center">Extension no.</th>
                <th className="align-center">Company</th>
                <th className="align-center">Profile</th>
                <th className="align-center">Department</th>
                <th className="align-center">Designation</th>
                <th className="align-center">Updated at</th>
                <th className="align-center">Updated by</th>
                <th className="align-center">Work Email</th>
                <th className="align-center">Contact no.</th>
                <th className="align-right width-10vw">Action</th>
              </tr>
            </thead>
            {buffer ? <div className="spinner"></div> : //buffering logic
              <tbody>
                {filteredInterCom
                  ?.filter((e) =>
                    e.extensionno.toString().includes(searchQuery.toLowerCase())
                  )
                  .sort((a, b) => a.extensionno - b.extensionno)
                  .map((i, index) => (
                    <React.Fragment key={index}>
                      <tr className="tr-border-bottom">
                        <td colSpan="6"></td>
                      </tr>
                      <tr className="custom-table-head-td">
                        <td className="align-left">{index + 1}</td>
                        <td className="align-center">{i.extensionno}</td>
                        <td className="align-center">{i.sub_company_title}</td>
                        {/* <td className="align-center">
                          <p>{i.user_detail}-{i.name}</p>
                        </td> */}
                        <td className="align-center">

                          <CustomImageModal
                            customStyle>
                            {i.profilepic ? (
                              <img
                                src={`${IMAGE_URL}${i.profilepic}`}
                                alt="profile" className="profile-img"
                              />
                            ) : (
                              <UserDefaultLogo user={{ name: i.name, profilepic: i.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'profile-img'} />
                            )}
                          </CustomImageModal>
                          <p>{i.user_detail}-{i.name}</p>

                        </td>
                        <td className="align-center">
                          {i.department}
                        </td>
                        <td className="align-center">
                          {i.designation}
                        </td>
                        <td className="align-center">
                          {formatDateTime(i.updated_at).shortfull}
                        </td>

                        <td className="align-center">
                          {i.updated_by &&
                            <CustomImageModal customStyle>
                              {i.updated_by_profilepic ? (
                                <img
                                  src={`${IMAGE_URL}${i.updated_by_profilepic}`}
                                  className="profile-img"
                                  alt={i?.updated_by_name}
                                />
                              ) : (
                                <UserDefaultLogo
                                  user={{ name: i.updated_by_name, profilepic: '' }} customStyleforParent={"reqOutDuty-default-logo"} customStyleforChild={'small-profile'}
                                />
                              )}
                            </CustomImageModal>
                          }
                          <p> {i.updated_by && `${i.updated_by} - `}{i.updated_by_name}</p>
                        </td>
                        <td className="align-center">{i.work_email}</td>
                        <td className="align-center">{i.contactno}</td>
                        <td className="align-right width-5vw ">
                          <InterComUpdate i={i} getintercom={getIntercomData} employeeList={empList} />
                          {PERMISSION_AUTHORITY && (
                            <InterComDelete i={i} getintercom={getIntercomData} />
                          )}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            }
          </table>
        </div>
      </div>
    </>
  );
};

const TLintercomTable = () => {
  const [show, setShow] = useState(false);
  const [buffer, setBuffering] = useState(true); //buffering logic

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [interCom, setInterCom] = useState([]);

  const getintercom = async () => {
    setBuffering(true); //buffering logic // Start Buffering 
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/intercomfilterbysubcompany/${sessionStorage.getItem(
          "company_id"
        )}/`
      );
      setInterCom(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  useEffect(() => {
    getintercom();
  }, []);

  return (
    <>
      <div className="table-css-white-background">
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500    font-size-heading">InterCom </div>
          <div></div>
        </div>
        <table className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">Sr.no</th>
              <th className="align-center">Extension no.</th>
              <th className="align-center">Company</th>
              <th className="align-center">User Detail</th>
              <th className="align-center">Department : Designation</th>
              <th className="align-center">Work Email</th>
              <th className="align-center">Contact no.</th>
            </tr>
          </thead>
          {buffer ? <div className="spinner"></div> : //buffering logic
            <tbody>
              {interCom
                .sort((a, b) => a.extensionno - b.extensionno)
                .map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{index + 1}</td>
                      <td className="align-center">{i.extensionno}</td>
                      <td className="align-center">{i.sub_company_title}</td>
                      <td className="align-center">
                        {i.user_detail}
                        <p>{i.name}</p>
                      </td>
                      <td className="align-center">
                        {i.department} : {i.designation}
                      </td>
                      <td className="align-center">{i.work_email}</td>
                      <td className="align-center">{i.contactno}</td>
                    </tr>
                  </React.Fragment>
                ))}
            </tbody>
          }
        </table>
      </div>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};

const EssLMachineTable = () => {
  const [show, setShow] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [buffer, setBuffering] = useState(true); //buffering logic
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [esslList, setEssslList] = useState([]);

  const getEssl = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/esslfilterbysubcompany/${sessionStorage.getItem(
          "company_id"
        )}/`
      );
      // const res = await axios.get(`${BASE_URL}/wfm/esslList/`);
      setEssslList(res.data);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };
  const matchesSearchQuery = (item, query) => {
    const lowerCaseQuery = query.toLowerCase();
    return (
      item.name.toLowerCase().includes(lowerCaseQuery) ||
      item.url.toLowerCase().includes(lowerCaseQuery) ||
      item.serial_number.toLowerCase().includes(lowerCaseQuery) ||
      item.sub_company_title.toLowerCase().includes(lowerCaseQuery)
    );
  };

  useEffect(() => {
    getEssl();
  }, []);

  return (
    <>
      <div className="table-css-white-background">
        <div className="table-heading-flex">
          <div className="repo-heading font-weight500    font-size-heading">Essl List </div>
          <div className="flex-row">
            <div className="table-searchh">
              <div>
                <SearchBig />
                <input
                  placeholder="Search"
                  className="navbar-inputt font-weight400  font-size-text"
                  value={searchQuery}
                  // min={0}
                  onChange={handleSearchChange}
                // type=""
                />
              </div>
            </div>
            {/* <EsslList getEssl={getEssl} /> */}
            {/* -+*9*- */}
          </div>
        </div>
        <table className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left">Sr.no</th>
              <th className="align-center">Name</th>
              <th className="align-center">URL</th>
              <th className="align-center">Serial No.</th>
              <th className="align-center">SubCompany</th>
              <th className="align-right width-10vw">Action</th>
            </tr>
          </thead>
          {buffer ? <div className="spinner"></div> : //buffering logic
            <tbody>
              {esslList
                ?.filter((e) => matchesSearchQuery(e, searchQuery))
                .sort((a, b) =>
                  a.name
                    .toString()
                    .localeCompare(b.name, "en", { ignorePunctuation: true })
                )
                .map((i, index) => (
                  <React.Fragment key={index}>
                    <tr className="tr-border-bottom">
                      <td colSpan="6"></td>
                    </tr>
                    <tr className="custom-table-head-td">
                      <td className="align-left">{index + 1}</td>
                      <td className="align-center">{i.name}</td>
                      <td className="align-center">{i.url}</td>
                      <td className="align-center">{i.serial_number}</td>
                      <td className="align-center">{i.sub_company_title}</td>
                      <td className="align-right width-5vw ">
                        {/* <EsslUpdate i={i} getEssl={getEssl} />
                    <EsslDelete i={i} getEssl={getEssl} /> */}
                      </td>
                    </tr>
                  </React.Fragment>
                ))}
            </tbody>
          }
        </table>
      </div>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};




const DepartmentHierarchyTable = () => {
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id") || "");
  const [toggleDepartment, setToggleDepartment] = useState("");

  // Lifted States
  const [departments, setDepartments] = useState([]);
  const [reportingHeads, setReportingHeads] = useState([]);
  const [loadingDepts, setLoadingDepts] = useState(false);
  const [loadingRH, setLoadingRH] = useState(false);

  const [hierarchies, setHierarchies] = useState([]);
  const [buffer, setBuffering] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // 1. Fetch Departments AND Reporting Heads when Company changes
  useEffect(() => {
    const fetchData = async () => {
      if (!toggleCompany || toggleCompany === "null") {
        setDepartments([]);
        setReportingHeads([]);
        setToggleDepartment("");
        return;
      }

      const fetchDepts = async () => {
        setLoadingDepts(true);
        try {
          const res = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${toggleCompany}/active/`);
          setDepartments(res.data);
        } catch (err) {
          console.error("Failed to fetch departments", err);
        } finally {
          setLoadingDepts(false);
        }
      };

      const fetchRHs = async () => {
        setLoadingRH(true);
        try {
          const res = await axios.get(`${BASE_URL}/wfm/rhlistactive/${toggleCompany}/active/`);
          setReportingHeads(res.data);
        } catch (err) {
          console.error("Failed to fetch reporting heads", err);
        } finally {
          setLoadingRH(false);
        }
      };

      fetchDepts();
      fetchRHs();
    };

    fetchData();
  }, [toggleCompany]);

  // 2. Fetch ALL Hierarchies for the selected Sub Company
  const getHierarchies = async () => {
    // if (!toggleCompany || toggleCompany === "null") {
    //   setHierarchies([]);
    //   return;
    // }

    try {
      setBuffering(true);
      const res = await axios.get(`${BASE_URL}/wfm/manual-hierarchy-filter/?sub_company=${toggleCompany}`);

      // API returns { status, count, data: [...] }
      // Filter out employee-level hierarchies by checking if department is NOT null
      const departmentHierarchies = res.data?.data?.filter(item => item.department !== null) || [];
      setHierarchies(departmentHierarchies);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  // Fetch hierarchies whenever the sub_company changes
  useEffect(() => {
    getHierarchies();
  }, [toggleCompany]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // manual_hierarchy.levels only carries the approver's emp_code, not their
  // name — resolve it from reportingHeads (already fetched for this sub_company).
  const getApproverName = (empCode) => {
    const match = reportingHeads?.find(rh => rh.emp_code === empCode);
    return match ? match.name : empCode;
  };

  // Helper to render the hierarchy chain beautifully
  const renderHierarchyChain = (levels) => {
    if (!levels || levels.length === 0) return <span style={{ color: '#707070' }}>No Hierarchy Configured</span>;

    const sortedLevels = [...levels].sort((a, b) => a.level - b.level);

    return (
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' }}>
        {sortedLevels.map((lvl, idx) => (
          <React.Fragment key={idx}>
            <span
              className="status-tag"
              style={{
                background: '#eff6ff',
                color: '#2576bc',
                border: '1px solid #bfdbfe',
                padding: '4px 12px',
                fontSize: '12px'
              }}
              title={`Approver ID: ${lvl.approver}`}
            >
              <strong>L{lvl.level}:</strong> {lvl.approver_name || getApproverName(lvl.approver)}
            </span>
            {idx < sortedLevels.length - 1 && (
              <span style={{ color: '#9ca3af', fontSize: '14px' }}>➔</span>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <div className="table-css-white-background">
      <div className="table-heading-flex">
        <div className="repo-heading font-weight500 font-size-heading">Department Hierarchy</div>

        <div className="field-cont">
          {/* Sub Company Filter */}
          {SUPER_ADMIN && (
            <div className="table-searchh dropdown-container field-cont-div">
              <Office />
              <select
                onChange={(e) => {
                  setToggleCompany(e.target.value);
                  setToggleDepartment(""); // Reset dept on company change
                }}
                value={toggleCompany}
                className="dropdown font-size-subheading"
              >
                <option value="null">Select SubCompany</option>
                {SUB_COMPANIES?.map(company => (
                  <option key={company.id} value={company.id}>{company.title}</option>
                ))}
              </select>
            </div>
          )}

          {/* Department Local Filter */}
          <div className="table-searchh dropdown-container field-cont-div">
            <select
              onChange={(e) => setToggleDepartment(e.target.value)}
              value={toggleDepartment}
              className="dropdown font-size-subheading"
              disabled={!toggleCompany || toggleCompany === "null"}
            >
              <option value="">Select Department</option>
              {departments?.map(dept => (
                <option key={dept.id} value={dept.id}>{dept.name || dept.title}</option>
              ))}
            </select>
          </div>

          <div className="table-searchh">
            <div>
              <SearchSmall />
              <input
                placeholder="Search..."
                className="navbar-inputt font-weight400 font-size-text"
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </div>

          {/* Add Component - Passing down the lifted states */}
          <DepartmentHierarchyAdd
            getHierarchies={getHierarchies}
            SUB_COMPANIES={SUB_COMPANIES}
            SUPER_ADMIN={SUPER_ADMIN}
            toggleCompany={toggleCompany}
            setToggleCompany={setToggleCompany}
            DEPARTMENTS={departments}
            EMPLOYEES={reportingHeads}
            loadingDepts={loadingDepts}
            loadingRH={loadingRH}
          />
        </div>
      </div>

      <table className="table-css">
        <thead>
          <tr className="custom-table-head-tr">
            <th className="align-left">Sr. No.</th>
            <th className="align-center">Department</th>
            <th className="align-center">Company</th>
            <th className="align-center">Hierarchy Configuration</th>
            <th className="align-center">Last Update</th>
            <th className="align-right width-5vw">Action</th>
          </tr>
        </thead>

        {buffer ? (
          <tbody>
            <tr>
              <td colSpan="6">
                <div className="spinner" style={{ margin: '20px auto' }}></div>
              </td>
            </tr>
          </tbody>
        ) : hierarchies?.length === 0 ? (
          <tbody>
            <tr>
              <td colSpan="6" style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
                No hierarchy configured for departments in this company yet.
              </td>
            </tr>
          </tbody>
        ) : (
          <tbody>
            {hierarchies?.filter((e) => {
              // Text search logic
              const matchesSearch = e.department_title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                e.subcompany_title?.toLowerCase().includes(searchQuery.toLowerCase());
              // Local department dropdown logic
              const matchesDept = toggleDepartment ? e.department === toggleDepartment : true;

              return matchesSearch && matchesDept;
            })
              .map((i, index) => (
                <React.Fragment key={index}>
                  <tr className="tr-border-bottom">
                    <td colSpan="6"></td>
                  </tr>
                  <tr className="custom-table-head-td">
                    <td className="align-left">{index + 1}</td>

                    {/* Using new keys from the updated payload */}
                    <td className="align-center font-weight500">{i.department_title || '-'}</td>
                    <td className="align-center">{i.subcompany_title || '-'}</td>

                    <td className="align-center">
                      {renderHierarchyChain(i.manual_hierarchy?.levels)}
                    </td>

                    <td className="align-center">
                      {i.updated_at ? (
                        <>
                          {formatDateTime(i.updated_at).longdate}
                          <br />
                          <small>{formatDateTime(i.updated_at).time}</small>
                        </>
                      ) : '-'}
                    </td>

                    <td className="align-right width-5vw">
                      <div className="flex-row justify-end">
                        <DepartmentHierarchyUpdate
                          i={i}
                          getHierarchies={getHierarchies}
                          SUB_COMPANIES={SUB_COMPANIES}
                          DEPARTMENTS={departments}
                          EMPLOYEES={reportingHeads} // Pass the RH list fetched in parent
                          SUPER_ADMIN={SUPER_ADMIN}
                        />
                        <DepartmentHierarchyDelete
                          i={i}
                          getHierarchies={getHierarchies}
                        />
                      </div>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
          </tbody>
        )}
      </table>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};




const EmployeeWiseHierarchyTable = () => {
  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
  // FIX #2: default to "null" (string) so it matches the "Select SubCompany" option value
  const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id") || "null");
  const [empList, setEmpList] = useState([]);
  const [buffer1, setBuffering1] = useState(true);
  // Lifted States
  const [reportingHeads, setReportingHeads] = useState([]);
  const [loadingRH, setLoadingRH] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [hierarchies, setHierarchies] = useState([]);
  const [buffer, setBuffering] = useState(false);



  useEffect(() => {
    const fetchData = async () => {
      if (!toggleCompany || toggleCompany === "null") {
        setReportingHeads([]);
        setEmpList([]);
        // return;
      }

      const getAllEmp_code = async () => {
        try {
          setBuffering1(true);
          setEmpList([]);

          const res = await axios.get(
            `${BASE_URL}/wfm/ourcompanyempdetailsactive/${toggleCompany}/`
          );

          setEmpList(customSortByKey(res.data, "emp_code"));
        } catch (err) {
          setEmpList([]);
        } finally {
          setBuffering1(false);
        }
      };

      const getReportingHeads = async () => {
        setLoadingRH(true);
        try {
          const res = await axios.get(`${BASE_URL}/wfm/rhlistactive/${toggleCompany}/active/`);
          setReportingHeads(res.data);
        } catch (err) {
          console.error("Failed to fetch reporting heads", err);
        } finally {
          setLoadingRH(false);
        }
      };

      await Promise.all([
        getAllEmp_code(),
        getReportingHeads()
      ]);
    };

    fetchData();
  }, [toggleCompany]);


  const getHierarchies = async () => {
    // if (!toggleCompany || toggleCompany === "null") {
    //   setHierarchies([]);
    //   return;
    // }

    try {
      setBuffering(true);
      const res = await axios.get(`${BASE_URL}/wfm/manual-hierarchy-filter/?sub_company=${toggleCompany}`);
      // API returns both department-level rows (employee: []) and
      // employee-level rows (employee: [emp_code, ...]). This table only
      // cares about employee-wise hierarchy, so keep rows that actually
      // have employees attached.
      const empHierarchy = res.data?.data?.filter(item => Array.isArray(item.employee) && item.employee.length > 0) || [];
      setHierarchies(empHierarchy);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  // Fetch hierarchies whenever the sub_company changes
  useEffect(() => {
    getHierarchies();
  }, [toggleCompany]);



  // manual_hierarchy.levels only carries the approver's emp_code, not their
  // name — resolve it from reportingHeads (already fetched for this sub_company).
  const getApproverName = (empCode) => {
    const match = reportingHeads?.find(rh => rh.emp_code === empCode);
    return match ? match.name : empCode;
  };

  // Helper to render the hierarchy chain beautifully
  const renderHierarchyChain = (levels) => {
    if (!levels || levels.length === 0) return <span style={{ color: '#707070' }}>No Hierarchy Configured</span>;

    const sortedLevels = [...levels].sort((a, b) => a.level - b.level);

    return (
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' }}>
        {sortedLevels.map((lvl, idx) => (
          <React.Fragment key={idx}>
            <span
              className="status-tag"
              style={{
                background: '#eff6ff',
                color: '#2576bc',
                border: '1px solid #bfdbfe',
                padding: '4px 12px',
                fontSize: '12px'
              }}
              title={`Approver ID: ${lvl.approver}`}
            >
              <strong>L{lvl.level}:</strong> {lvl.approver_name || getApproverName(lvl.approver)}
            </span>
            {idx < sortedLevels.length - 1 && (
              <span style={{ color: '#9ca3af', fontSize: '14px' }}>➔</span>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  // Helper to render the list of employees this hierarchy row applies to
  const renderEmployeeChips = (employeeDetails) => {
    if (!employeeDetails || employeeDetails.length === 0) return "-";

    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', justifyContent: 'center' }}>
        {employeeDetails.map((emp, idx) => (
          <span
            key={emp.emp_code || idx}
            className="status-tag"
            style={{
              background: '#f3f4f6',
              color: '#374151',
              border: '1px solid #e5e7eb',
              padding: '4px 10px',
              fontSize: '12px'
            }}
            title={emp.emp_code}
          >
            {emp.name}
          </span>
        ))}
      </div>
    );
  };

  // Filter hierarchies by locally-selected employee (if any)
  const visibleHierarchies = selectedEmployee
    ? hierarchies.filter(item => item.employee?.includes(selectedEmployee))
    : hierarchies;

  return (
    <div className="table-css-white-background">
      <div className="table-heading-flex">
        <div className="repo-heading font-weight500 font-size-heading">Employee Hierarchy</div>

        <div className="field-cont">
          {/* Sub Company Filter */}
          {SUPER_ADMIN && (
            <div className="table-searchh dropdown-container field-cont-div">
              <Office />
              <select
                onChange={(e) => {
                  setToggleCompany(e.target.value);
                  setSelectedEmployee(""); // Reset employee on company change
                }}
                value={toggleCompany}
                className="dropdown font-size-subheading"
              >
                <option value="null">Select SubCompany</option>
                {SUB_COMPANIES?.map(company => (
                  <option key={company.id} value={company.id}>{company.title}</option>
                ))}
              </select>
            </div>
          )}

          {/* Employee Local Filter */}
          <div className="table-searchh dropdown-container field-cont-div">
            <select
              value={selectedEmployee}
              onChange={(e) => setSelectedEmployee(e.target.value)}
              className="dropdown font-size-subheading"
            // disabled={!toggleCompany || toggleCompany === "null"}
            >
              <option value="">Select Employee</option>
              {empList?.map(emp => (
                <option key={emp.emp_code} value={emp.emp_code}>{emp.name} - {emp.emp_code}</option>
              ))}
            </select>
          </div>

          <EmployeeHierarchyAdd
            getHierarchies={getHierarchies}
            EMPLOYEELIST={empList}
            employeeLoading={buffer1}
            RHLIST={reportingHeads}
            loadingRH={loadingRH}
            SUB_COMPANIES={SUB_COMPANIES}
            SUPER_ADMIN={SUPER_ADMIN}
            toggleCompany={toggleCompany}
          />
        </div>
      </div>

      <table className="table-css">
        <thead>
          <tr className="custom-table-head-tr">
            <th className="align-left">Sr. No.</th>
            <th className="align-center">Employee(s)</th>
            <th className="align-center">Company</th>
            <th className="align-center">Hierarchy Configuration</th>
            <th className="align-center">Created At</th>
            <th className="align-center">Last Update</th>
            <th className="align-right width-5vw">Action</th>
          </tr>
        </thead>

        {buffer ? (
          <tbody>
            <tr>
              <td colSpan="6">
                <div className="spinner" style={{ margin: '20px auto' }}></div>
              </td>
            </tr>
          </tbody>
        ) : visibleHierarchies?.length === 0 ? (
          <tbody>
            <tr>
              <td colSpan="6" style={{ textAlign: 'center', padding: '40px', color: '#6b7280' }}>
                No hierarchy configured for employees in this company yet.
              </td>
            </tr>
          </tbody>
        ) : (
          // FIX #1: rows were never rendered before — hierarchies data was fetched
          // but the tbody was always left empty. Now actually mapping over it.
          <tbody>
            {visibleHierarchies.map((item, index) => (
              <tr key={item.id || index} className="custom-table-head-td">
                <td className="align-left">{index + 1}</td>
                <td className="align-center">{renderEmployeeChips(item.employee_details)}</td>
                <td className="align-center">{item.subcompany_title || "-"}</td>

                <td className="align-center">
                  {renderHierarchyChain(item.manual_hierarchy?.levels)}
                </td>

                {/* <td className="align-center">
                  {item.updated_at ? new Date(item.updated_at).toLocaleDateString() : "-"}
                  {item.updated_by_name && (
                    <div style={{ fontSize: '11px', color: '#9ca3af' }}>by {item.updated_by_name}</div>
                  )}
                </td> */}

                <td className="align-center">
                  {formatDateTime(item?.created_at).shortfull}
                </td>

                <td className="align-center">
                  <>
                    {item.updated_by &&
                      <>
                        <CustomImageModal customStyle>
                          {item.updated_by_profilepic ? (
                            <img
                              src={`${`${IMAGE_URL}${item.updated_by_profilepic}`}`}
                              alt="profile" className="profile-img"
                            />
                          ) : (
                            <UserDefaultLogo user={{ name: item.updated_by_name, profilepic: item.updated_by_profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile'} />
                          )}
                        </CustomImageModal>
                        <p>{`${item.updated_by} - `}{item.updated_by_name}</p>
                        {/* At- */}
                      </>
                    }
                    <small>{item?.updated_at && formatDateTime(item?.updated_at).shortfull}</small>
                  </>
                </td>

                <td className="align-right width-5vw">
                  <div className="flex-row justify-end">
                    <EmployeeHierarchyUpdate
                      i={item}
                      getHierarchies={getHierarchies}
                      EMPLOYEELIST={empList}
                      employeeLoading={buffer1}
                      RHLIST={reportingHeads}
                      loadingRH={loadingRH}
                      SUB_COMPANIES={SUB_COMPANIES}
                      SUPER_ADMIN={SUPER_ADMIN}
                      toggleCompany={toggleCompany}
                    />
                    <EmployeeHierarchyDelete
                      i={item}
                      getHierarchies={getHierarchies}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        )}
      </table>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
};


export {
  DepartmentTable,
  DesignationTable,
  Subcompany,
  Worksite,
  AttendancePolicyTable,
  WeeklyOffPolicyTable,
  SalaryStructureHeadingTable,
  SalaryStructureFormatTable,
  SalaryCalculationPolicyTable,
  CalenderTable,
  TlCalenderTable,
  InterComTable,
  TLintercomTable,
  EmployeebyDepartmentTable,
  EssLMachineTable,
  EmployeeWiseHierarchyTable,
  DepartmentHierarchyTable
};
